import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import { InputField, SelectField } from 'Common/SemanticWrapper';
import { InputMode } from 'Common/FormEnum';
import { IncomeEnum } from 'Common/Constants/Enumeration/IncomeEnum';
import { convertEnumToDropdownArray } from 'Common/Constants/Enumeration/ConvertEnumToDropdownArray';
import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';
import { TitledCard } from 'Components';
import { formatDecimalShowZeroAsNull } from 'Common/FormHelper';

export class IncomeForm extends Component {
  frequencies = convertEnumToDropdownArray(IncomeEnum, true);

  normalizeAmount = value => {
    return value && value !== 0 ? value : '';
  };

  render() {
    const { memberName } = this.props;
    return (
      <TitledCard title={`${memberName} Income`}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={7} verticalAlign={'bottom'} />
            <Grid.Column width={4} verticalAlign={'bottom'}>
              <label>Amount</label>
            </Grid.Column>
            <Grid.Column width={5} verticalAlign={'bottom'}>
              <label>Frequency</label>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={7}>
              <label>Salary</label>
            </Grid.Column>
            <Grid.Column width={4}>
              <Field
                label={null}
                component={InputField}
                mode={InputMode.Decimal}
                name={Fields.Income1}
                type={'text'}
                numericSize={[12, 2]}
                format={this.normalizeAmount}
                formatOnBlur={formatDecimalShowZeroAsNull(2)}
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <Field
                name={Fields.Freq1}
                component={SelectField}
                type={'text'}
                maxLength={1}
                options={this.frequencies}
                style={{ zIndex: 99 }}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={7} verticalAlign={'middle'}>
              <label>Welfare / Alimony / Child Support</label>
            </Grid.Column>
            <Grid.Column width={4}>
              <Field
                label={null}
                component={InputField}
                mode={InputMode.Decimal}
                name={Fields.Income2}
                type={'text'}
                numericSize={[12, 2]}
                format={this.normalizeAmount}
                formatOnBlur={formatDecimalShowZeroAsNull(2)}
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <Field
                name={Fields.Freq2}
                component={SelectField}
                type={'text'}
                maxLength={1}
                options={this.frequencies}
                style={{ zIndex: 98 }}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={7} verticalAlign={'middle'}>
              <label>Retirement / Pension / Social Security</label>
            </Grid.Column>
            <Grid.Column width={4}>
              <Field
                label={null}
                component={InputField}
                mode={InputMode.Decimal}
                name={Fields.Income3}
                type={'text'}
                numericSize={[12, 2]}
                format={this.normalizeAmount}
                formatOnBlur={formatDecimalShowZeroAsNull(2)}
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <Field
                name={Fields.Freq3}
                component={SelectField}
                type={'text'}
                maxLength={1}
                options={this.frequencies}
                style={{ zIndex: 97 }}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={7} verticalAlign={'middle'}>
              <label>Other</label>
            </Grid.Column>
            <Grid.Column width={4}>
              <Field
                label={null}
                component={InputField}
                mode={InputMode.Decimal}
                name={Fields.Income4}
                type={'text'}
                numericSize={[12, 2]}
                format={this.normalizeAmount}
                formatOnBlur={formatDecimalShowZeroAsNull(2)}
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <Field
                name={Fields.Freq4}
                component={SelectField}
                type="text"
                maxLength={1}
                options={this.frequencies}
                style={{ zIndex: 96 }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </TitledCard>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/manageapplication/components/hub/IncomeForm.js